export const SPAM_TYPES = [
  {
    value: 1,
    label: "Nudity or sexual activity",
  },
  {
    value: 2,
    label: "It’s spam",
  },
  {
    value: 3,
    label: "Fake Account",
  },
  {
    value: 4,
    label: "Hate speech",
  },
  {
    value: 5,
    label: "Violence",
  },
  {
    value: 6,
    label: "Sale of illegal activities",
  },
  {
    value: 7,
    label: "Bullying or harassment",
  },
  {
    value: 8,
    label: "Intellectual property violation",
  },
  {
    value: 9,
    label: "Scam or Fraud",
  },
  {
    value: 10,
    label: "False Information",
  },
  //   {
  //     value: 11,
  //     label: "I am not interested in it",
  //   },
  {
    value: 0,
    label: "Others",
  },
];
